import zhCommon from "./zh/common";
import zhHome from "./zh/home";
import zhCategory from "./zh/category";
import zhArticle from "./zh/article";
import zhAbout from "./zh/about";

const resources = {
  zh: {
    common: zhCommon,
    home: zhHome,
    category: zhCategory,
    article: zhArticle,
    about: zhAbout,
  },
};

export default resources;